import { lazy } from 'react';

export const CountryPageLazy = lazy(() => import('./CountryPage'));
